/**
 * Up/down colors for Highcharts series, shared by the restyled charts. Fixed hex rather than the Hoist
 * intent vars - Highcharts needs parseable colors to build gradient fills and translucent variants.
 */
export const CHART_UP_COLOR = '#2ea043';
export const CHART_DOWN_COLOR = '#e5484d';

/** Neutral series color - matches the terminal flat fill. */
export const CHART_FLAT_COLOR = '#6b7785';

/** Benchmark (SPX) series - a cool blue that stays apart from the up/down colors. */
export const BENCHMARK_COLOR = '#58a6ff';

/** Vertical gradient fill for an area series, from a faint tint of `color` at the top to transparent. */
export function areaGradient(color: string, topAlpha: string = '59') {
    return {
        linearGradient: {x1: 0, y1: 0, x2: 0, y2: 1},
        stops: [
            [0, `${color}${topAlpha}`],
            [1, `${color}00`]
        ]
    };
}
